var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLabelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19C4.45 19 3.979 18.8043 3.587 18.413C3.19567 18.021 3 17.55 3 17V7C3 6.45 3.19567 5.97933 3.587 5.588C3.979 5.196 4.45 5 5 5H15C15.3333 5 15.646 5.075 15.938 5.225C16.2293 5.375 16.4667 5.58333 16.65 5.85L20.175 10.85C20.4083 11.2 20.525 11.5833 20.525 12C20.525 12.4167 20.4083 12.8 20.175 13.15L16.65 18.15C16.4667 18.4167 16.2293 18.625 15.938 18.775C15.646 18.925 15.3333 19 15 19H5ZM18.55 12L15 7H5V17H15L18.55 12ZM5 12V17V7V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLabelOutline);
export default __webpack_public_path__ + "static/media/ico-label-outline.cb631f7245b8695ecf1f427ea348f562.svg";
export { ForwardRef as ReactComponent };